import React, { useEffect, useState, useMemo, useRef } from "react";
import Button from "react-bootstrap/Button";
import moment from 'moment-timezone';
import { Calendar, momentLocalizer, View as CalendarView } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { useAuth } from "../../../firebase/AuthProvider";
import { toast } from "react-toastify";
import {
  deleteEvent,
  getAllEmployees,
  getAllEvents,
  getAllLeaves,
  getAllTeam,
  getAllTemaEvents,
  getMyParticipantsAndCoworkers,
  getMyTeams,
} from "../../../services/calendarService/EventService";
import {
  AllEvent,
  AllEventTeam,
  AllEventTeams,
  AllTeams,
  AllUsers,
  TimeOffEmpData,
} from "../../../interfaces/identity/calendar/Events";
import AddEvent from "./events/AddEvent";
import ViewEvent from "./events/ViewEvent";
import Modal from "./events/Model";
import Loader from "../loader/Loader";
import { useLocation } from "react-router-dom";
import "./calender.css";
import SelectDropdown from "../../ui/Dropdown/SelectDropdown";
import MultiSelectDropdown from "../../ui/Dropdown/MultiSelectDropdown";
import Team from "../../../interfaces/identity/Team";
import { CALENDAR_VIEW } from "../../../Data/SD";
import { expandRecurringEvents } from "../../../utilities/eventUtils";
import profileImg from "../../../assets/images/profileimg.png";
import ADD from "../../../assets/images/ADD.png";
import { Event } from "../../../interfaces/Event";
import EventCard from "./EventCard";
import BellowModal from "./BellowModal";
import SmartPositionModal from "./SmartPositionModal";
import ModalMeet from "./ModalMeet";
import CustomToolbar from "./CustomToolbar";
import RescheduleMeetingModal from '../tasks/Modals/RescheduleMeetingModal';
import { showConfirmationDialog } from "../../modal/ConfimationModal/Confimation";
import { FaStar } from "react-icons/fa";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import AvatarImage from "../../ui/Avatar/AvatarImage";
import UserAvatar from "./UserAvatar";
import HolidaySidebar from "../Holiday/HolidaySidebar";
import MeetingTypeInfo from "./MeetingTypeInfo";

const localizer = momentLocalizer(moment);



const CustomWeekHeader: React.FC<any> = ({ date }) => {
  // date is the date for this column's header
  const isToday = date.toDateString() === new Date().toDateString();
  const day = date.getDay();
  const isWeekend = day === 0 || day === 6; // Sun or Sat

  // If you want to highlight a selected date coming from parent,
  return (
    <div className="flex justify-center">
      <div
        className={`w-full h-16 ${isToday ? "bg-transparent" : isWeekend ? "bg-[#FAFAFA]" : "bg-transparent"} rounded-md px-2 pt-1.5`}
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      // keep pointer-events none if you don't want clicks on header
      >
        <span className={`text-[8px] md:text-xs xl:text-sm font-semibold ${isToday ? "text-[#71717A]" : "text-[#71717A]"}`}>
          {moment(date).format("ddd").toUpperCase()}
        </span>
        <span className={`text-base md:text-lg xl:text-xl font-semibold mt-0.5 ${isToday ? "text-gray-900" : "text-black"}`}>
          {moment(date).format("D")}
        </span>
      </div>
    </div>
  );
};

const MonthHeader: React.FC<any> = ({ date }) => {
  return (
    <div className="flex justify-center items-center py-2 sm:py-3 border-t-2 border-[#F5F6F7] bg-white">
      {/* Small screens (SUN, MON, TUE) */}
      <span className="block lg:hidden text-[10px] font-medium text-[#4F4F4F]">
        {moment(date).format("ddd").toUpperCase()}
      </span>

      {/* Medium+ screens (Sunday, Monday, Tuesday) */}
      <span className="hidden lg:block text-[14px] font-medium text-[#4F4F4F]">
        {moment(date).format("dddd")}
      </span>
    </div>

  );
};

const DayHeader = ({ date }: { date: Date }) => {
  return (
    <div className="py-[11px] bg-[#7E57C21A] text-center w-full">
      {/* Day name */}
      <div className="font-poppins text-sm 2xl:text-[16px] leading-[20px] font-normal text-[#4A5565] text-center">
        {moment(date).format("dddd")}
      </div>

      {/* Full date */}
      <div className="font-poppins text-[18px] 2xl:text-[20px] mt-1 leading-[32px] font-normal text-[#101828] text-center">
        {moment(date).format("MMMM D, YYYY")}
      </div>
    </div>
  );
};

const formats = {
  weekdayFormat: (date: Date) => moment(date).format("ddd").toUpperCase(),
  dayFormat: (date: Date) => moment(date).format("D"),
};

const hexToRgba = (hex: string, alpha: number) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

const MyCalendar: React.FC = () => {
  const { currentUser, currentRoles } = useAuth();
  const isOwner = currentRoles?.some(role => role.name === 'OWNER');
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const dateParam = params.get("date");
  const initialDate = dateParam ? moment(dateParam).toDate() : new Date();
  const userId = (currentUser as any)?.uid;
  const token = (currentUser as any)?.accessToken;
  const initialView: CalendarView = dateParam ? "day" : "month";
  const [currentView, setCurrentView] = useState<CalendarView>(initialView);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState<AllEvent | null>(null);
  const [loading, setLoading] = useState(false);
  const [currentDate, setCurrentDate] = useState<Date>(initialDate);
  const [calendarEvents, setCalendarEvents] = useState<AllEvent[]>([]);
  const [employees, setEmployees] = useState<AllUsers[]>([]);
  const [selectedEmployees, setSelectedEmployees] = useState<(string | number)[]>([]);
  const [eventTeam, setEventTeam] = useState<AllEventTeam | null>(null);
  const [filteredTeamEvents, setFilteredTeamEvents] = useState<AllEventTeams[]>([]);
  const [teams, setTeams] = useState<Team[]>([]);
  const [selectedTeam, setSelectedTeam] = useState<string>("");
  const [empleavedata, setEmpLeaveData] = useState<TimeOffEmpData[]>([]);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const [selectedSidebarDate, setSelectedSidebarDate] = useState<Date>(new Date());
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [showRescheduleModal, setShowRescheduleModal] = useState(false);
  const [openHoliday, setHolidayOpen] = useState(false);
  const Star = FaStar as any;

  const colors = [
    "bg-red-500",
    "bg-green-500",
    "bg-orange-500",
    "bg-purple-500",
    "bg-yellow-500",
    "bg-pink-500",
    "bg-teal-500",
  ];

  const getColor = (name: string) =>
    colors[name.charCodeAt(0) % colors.length];

  const getInitials = (name: string) => {
    if (!name) return "";

    const words = name.trim().split(" ");

    // If multiple words → take first letter of first two words
    if (words.length >= 2) {
      return (words[0][0] + words[1][0]).toUpperCase();
    }

    // Single word → take first letter only
    return words[0][0].toUpperCase();
  };

  const lightenHex = (hex: string, amount = 0.85) => {
    let c = hex.replace("#", "");

    if (c.length === 3) {
      c = c.split("").map((x) => x + x).join("");
    }

    const num = parseInt(c, 16);

    let r = (num >> 16) & 255;
    let g = (num >> 8) & 255;
    let b = num & 255;

    r = Math.round(r + (255 - r) * amount);
    g = Math.round(g + (255 - g) * amount);
    b = Math.round(b + (255 - b) * amount);

    return `rgb(${r}, ${g}, ${b})`;
  };


  const CustomEvent = ({ event }: any) => {
    const baseColor = event.ownerColor || "#FF8904";
    const startTime = moment.utc(event.start).local().format("hh:mm A");
    const isPendingInvite =
      event.isInvitationAccept === null ||
      event.isInvitationAccept === undefined;

    const isWeekView = currentView === "week";
    const isDayView = currentView === "day";

    // const rgbaColor = hexToRgba(baseColor, 0.2);
    const lightBgColor = lightenHex(baseColor, 0.85);

    const ownerName = event.ownerName || "";
    const initials = getInitials(ownerName);
    const avatarBg = getColor(ownerName);

    const ownerImage = event.ownerImage; // optional

    const bg = isPendingInvite ? "#000029" : baseColor


    return (
      <div className={`z-10 overflow-hidden flex ${isDayView ? "w-1/3" : "w-full"} 
        ${isWeekView ? "items-start whitespace-normal" : "items-center whitespace-nowrap"} 
        gap-[6px] px-1 xl:px-2 xl:py-1 text-[13px] text-ellipsis
         md:border-l-[1.6px] xl:border-l-[2.7px] rounded-[3px] xl:rounded-[4.96px]
         `}
        style={{
          background: isPendingInvite ? "#FFFFFF" : lightBgColor,
          color: isPendingInvite ? "#414141" : baseColor,

          /* Border color */
          borderColor: isPendingInvite ? "#414141" : baseColor,
          borderLeftColor: isPendingInvite ? "#414141" : baseColor,

          /* Border styles */
          borderStyle: isPendingInvite ? "dashed" : "solid",

          /* Border widths */
          borderWidth: isPendingInvite ? "1px" : "0px",
          borderLeftWidth: isPendingInvite
            ? "1px"
            : window.innerWidth >= 1280
              ? "2.7px"
              : window.innerWidth >= 768
                ? "1.6px"
                : "0px",
        }}
      >
        {/* Avatar */}
        {currentView !== "day" && (
          <div
          // style={{
          //   background: isPendingInvite ? "#414141" : baseColor,
          // }}
          >
            <UserAvatar color={bg} userId={event?.ownerUserID} displayName={initials} className={`hidden xl:flex items-center justify-center ${avatarBg} ${isWeekView ? "w-8 h-8" : "w-3 h-3 2xl:w-4 2xl:h-4"} rounded-full text-white font-medium ${isWeekView ? "text-sm" : "!text-[8px] 2xl:!text-[10px]"} flex-shrink-0 ${isWeekView ? "mt-0.5" : "mt-0"}`} />
          </div>
        )}
        {/* Content */}
        {
          isWeekView ? (
            // 🔹 WEEK VIEW → TWO LINES
            <div className="flex flex-col justify-center overflow-hidden h-full py-[3px] px-0">
              <span style={{ color: isPendingInvite ? "#414141" : baseColor, }} className="hidden lg:block">
                {startTime}
              </span>

              <span
                className="truncate overflow-hidden capitalize text-[8px] md:text-[10px] 2xl:text-[13px]"
                style={{
                  textOverflow: "ellipsis",
                  color: isPendingInvite ? "#414141" : baseColor,
                }}
              >
                {event.title}
              </span>
            </div>
          ) : (
            // 🔹 OTHER VIEWS → ONE LINE
            <>
              <span style={{ color: isPendingInvite ? "#414141" : baseColor, }} className="hidden lg:block text-[10px] 2xl:text-[13px]">
                {startTime}
              </span>
              <span
                className="capitalize  text-[8px] md:text-[10px] 2xl:text-[13px]"
                style={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  color: isPendingInvite ? "#414141" : baseColor,
                }}
              >
                {event.title}
              </span>
            </>
          )
        }
      </div>
    );
  };


  const scrollToTime = dateParam
    ? moment(dateParam).set({ second: 0, millisecond: 0 }).toDate()
    : moment().set({ hour: 9, minute: 0, second: 0, millisecond: 0 }).toDate();

  async function fetchAllEvents() {
    if (!currentUser) return;
    setLoading(true);
    try {
      const view = currentView === 'work_week' ? 'week' : currentView === 'agenda' ? 'day' : currentView;
      const viewStart = moment(currentDate).startOf(view as moment.unitOfTime.StartOf).toDate();
      const viewEnd = moment(currentDate).endOf(view as moment.unitOfTime.StartOf).toDate();
      const response = await getAllEvents(token, viewStart, viewEnd);
      if (response) {
        setCalendarEvents(response);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  }

  // Add delete event function
  const handleDeleteEvent = async (event: AllEvent) => {
    if (!token) return;

    // Check if event is recurring
    if (event.recurrenceRule || event.parentEventId) {
      // For recurring events, we would need to show a scope modal
      // For now, we'll just show a confirmation dialog
      const isConfirmed = await showConfirmationDialog();
      if (isConfirmed) {
        await executeDeleteEvent(event, 'single');
      }
    } else {
      // For single events, confirm directly
      const isConfirmed = await showConfirmationDialog();
      if (isConfirmed) {
        await executeDeleteEvent(event, 'single');
      }
    }
  };

  // Execute the delete event
  const executeDeleteEvent = async (event: AllEvent, scope: 'single' | 'future') => {
    if (!token) return;
    setLoading(true);
    try {
      const success = await deleteEvent(event.id, token, scope);
      if (success) {
        toast.success('Event deleted successfully!');
        fetchAllEvents();
      } else {
        toast.error('Failed to delete the event.');
      }
    } catch (error) {
      console.error('Error deleting event:', error);
      toast.error('An error occurred.');
    } finally {
      setLoading(false);
    }
  };

  // Add reschedule event function
  const handleRescheduleEvent = (event: AllEvent) => {
    setSelectedEvent(event);
    setShowRescheduleModal(true);
  };

  const filteredExpandedEvents = useMemo(() => {
    const view = currentView === 'work_week' ? 'week' : currentView === 'agenda' ? 'day' : currentView;
    const viewStart = moment(currentDate).startOf(view as moment.unitOfTime.StartOf).toDate();
    const viewEnd = moment(currentDate).endOf(view as moment.unitOfTime.StartOf).toDate();

    const expanded: Event[] = expandRecurringEvents(calendarEvents, viewStart, viewEnd);

    const mappedEvents: AllEvent[] = expanded.map(e => {
      const originalEvent = calendarEvents.find(orig => orig.id === e.originalEventId);
      return {
        ...originalEvent!,
        id: e.id,
        title: e.title,
        start: e.date,
        end: moment(e.date).add(e.elapsedTimeInMinutes, 'minutes').toDate(),
        startTime: e.date.toISOString(),
        endTime: moment(e.date).add(e.elapsedTimeInMinutes, 'minutes').toISOString(),
        originalEventId: e.originalEventId,
        parentEventId: e.parentEventId,
        recurrenceRule: e.recurrenceRule,
        time_zone: e.time_zone,
      };
    });

    if (selectedEmployees.length > 0) {
      return mappedEvents.filter((event) =>
        event.participantUserIds.some((id) => selectedEmployees.includes(id)) || selectedEmployees.includes(event.ownerUserID)
      );
    }

    return mappedEvents;
  }, [calendarEvents, currentView, currentDate, selectedEmployees]);

  async function GetallLeavedata() {
    if (!currentUser) return;
    try {
      const response = await getAllLeaves(userId, token);
      if (response) {
        setEmpLeaveData(response);
      }
    } catch (error) { }
  }

  async function fetchAllEmployee() {
    if (!currentUser) return;
    setLoading(true);
    try {
      const response = await getMyParticipantsAndCoworkers(token);
      // const response = await getAllEmployees(token);
      // console.log(response.filter((user) => user.type === 'Employee'));
      // console.log(response.filter((user) => user.type === 'Participant'));
      if (response) {
        setEmployees(response);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  }

  const clearSelection = () => {
    setSelectedEmployees([]);
  };

  async function fetchAllTeamEvents(teamId: string) {
    if (!currentUser || !teamId) return;
    setLoading(true);
    try {
      const response = await getAllTemaEvents(token, parseInt(teamId));
      if (response) {
        setEventTeam(response);
        const ownerEvents = response.owners?.[0]?.events || [];
        const programManagers = response.programManagers?.[0]?.events || [];
        const supervisors = response.supervisors?.[0]?.events || [];
        const supportCoordinators = response.supportCoordinators?.[0]?.events || [];
        const ownertimeoffdata = response.owners?.[0]?.timeoffData || [];
        const Programmangertimeoffdata = response.programManagers?.[0]?.timeoffData || [];
        const supervisorstimeoffdata = response.supervisors?.[0]?.timeoffData || [];
        const supportCoordinatorstimeoffdata = response.supportCoordinators?.[0]?.timeoffData || [];
        const allTimeOffData = [...ownertimeoffdata, ...Programmangertimeoffdata, ...supervisorstimeoffdata, ...supportCoordinatorstimeoffdata];
        const transformedTimeOffEvents = transformLeavesToEvents(allTimeOffData);
        const allTeamEvents: any = [...ownerEvents, ...programManagers, ...supervisors, ...supportCoordinators, ...transformedTimeOffEvents];
        setFilteredTeamEvents(allTeamEvents);
      }
    } catch (error) {
      console.error("Error fetching team events:", error);
    } finally {
      setLoading(false);
    }
  }

  async function fetchAllTeam() {
    if (!currentUser) return;
    setLoading(true);
    try {
      const response = await getMyTeams(token);
      if (response) {
        setTeams(response);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  }

  const transformLeavesToEvents = (empleavedata: any = []) => {
    return empleavedata
      .filter((leave: any) => leave?.startDate && leave?.endDate)
      .map((leave: any) => ({
        title: "Employee time Off",
        startTime: leave.startDate,
        endTime: leave.endDate,
        timeOffEmpData: [{
          userId: leave.userId,
          userName: leave.userName,
          leave_type: leave.leave_type,
          user_color: leave.user_color,
          startDate: leave.startDate,
          endDate: leave.endDate,
        }],
      }));
  };

  useEffect(() => {
    if (selectedTeam) {
      fetchAllTeamEvents(selectedTeam);
    }
  }, [selectedTeam]);

  useEffect(() => {
    fetchAllEvents();
    fetchAllEmployee();
    fetchAllTeam();
    GetallLeavedata();
  }, []);

  const getEventPropGetter = (event: any) => {
    // const baseColor = event.ownerColor || "#CA3500"; // Default color
    const style: React.CSSProperties = {
      // background: `#FFEDD4`, // Event background
      // borderLeft: `2.48px solid ${baseColor}`, // Left border color
      // borderRadius: "4.96px", // Rounded corners
      // height: "25px", // Standard height, can be adjusted for larger events
      // display: "flex",
      // alignItems: "center", // Vertically center the text
      // padding: "0 8px", // Horizontal padding for text

      // /* Text style as per Figma */
      // fontFamily: "Poppins, sans-serif",
      // fontWeight: 400,
      // fontSize: "14px", // Text size for events
      // lineHeight: "19.86px",
      // color: `${baseColor} !important`, // Text color to match border

      // /* Event Spacing and Overflow */
      // marginBottom: "4px", // Space between events
      // overflow: "hidden", // Prevent text from overflowing
      // whiteSpace: "nowrap", // Prevent wrapping
      // textOverflow: "ellipsis", // Add ellipsis when text overflows

      // /* Optional striped effect if overlapping */
      // ...(event.timeOffEmpData?.length > 0 && {
      //   background: `repeating-linear-gradient(
      //   -45deg,
      //   ${hexToRgba(baseColor, 0.15)} 0px,
      //   ${hexToRgba(baseColor, 0.15)} 10px,
      //   ${hexToRgba(baseColor, 0.3)} 10px,
      //   ${hexToRgba(baseColor, 0.3)} 20px
      // )`,
      // }),
    };

    return { style };
  };

  const handleParticipantChange = (selectedValues: (string | number)[]) => {
    setSelectedEmployees(selectedValues);
  };

  const participantOptions = employees.map(emp => ({
    label: emp.userName,
    value: emp.userId,
    roles: emp.roles
  }));

  const handleTeamChange = (value: string | number) => {
    const teamId = typeof value === 'string' ? value : value.toString();
    setSelectedTeam(teamId);
    if (teamId) {
      fetchAllTeamEvents(teamId);
    } else {
      fetchAllEvents();
    }
  };

  const allHolidays = useMemo(() => {
    const map = new Map<number, any>();

    calendarEvents.forEach((event: any) => {
      (event.holidays || []).forEach((h: any) => {
        if (!map.has(h.id)) {
          map.set(h.id, h);
        }
      });
    });

    return Array.from(map.values());
  }, [calendarEvents]);

  const getHolidayPosition = (date: moment.Moment, holiday: any) => {
    const start = moment(holiday.startDate).startOf("day");
    const end = moment(holiday.endDate).endOf("day");

    if (date.isSame(start, "day")) return "start";
    if (date.isSame(end, "day")) return "end";
    if (date.isBetween(start, end, "day", "()")) return "middle";
    return null;
  };

  const calendarClassName = selectedDate
    ? "date-selected"
    : "date-not-selected";

  const teamOptions = teams.map(team => ({
    label: team.teamName,
    value: team.id.toString()
  }));

  const HolidayDateCellWrapper = ({ value, children }: any) => {
    const date = moment(value).startOf("day");

    const holidaysForDate = allHolidays
      .map(h => {
        const position = getHolidayPosition(date, h);
        return position ? { ...h, position } : null;
      })
      .filter(Boolean);

    const getMaxChars = () => {
      if (window.innerWidth >= 1280) return 10; // xl
      return 4; // smaller screens
    };

    if (!holidaysForDate.length) return <>{children}</>;

    const hasStartHoliday = holidaysForDate.some(h => h.position === "start");

    return (
      <div className="rbc-day-bg relative bg-[#F9F6FF] h-full w-full ">
        {/* LEFT BORDER → ONLY ON START DAY */}
        {hasStartHoliday && (
          <div className="absolute -left-[3px] top-0 h-full w-[1px] lg:w-[2px] bg-[#7E57C2]" />
        )}

        {/* STAR → ONLY ON START DAY */}
        {hasStartHoliday && (
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip>
                {holidaysForDate
                  .filter(h => h.position === "start")
                  .map(h => (
                    <div key={h.id}>{h.title}</div>
                  ))}
              </Tooltip>
            }
          >
            <span className="absolute top-1 right-1 z-10">
              <Star className="text-[#7E57C2] text-sm" />
            </span>
          </OverlayTrigger>
        )}

        {/* CONTENT FLOW (IMPORTANT) */}
        <div className="relative pt-[26px] px-1">
          {/* HOLIDAY TITLE */}
          {holidaysForDate
            .filter(h => h.position === "start")
            .map(h => {
              const maxChars = getMaxChars();
              const title =
                h.title.length > maxChars
                  ? h.title.slice(0, maxChars) + "..."
                  : h.title;

              return (
                <div
                  key={h.id}
                  className="text-[#7E57C2] text-[8px] lg:text-xs 2xl:text-sm font-medium mb-1 capitalize ps-2"
                  title={h.title} // ✅ full title on hover
                >
                  {title}
                </div>
              );
            })}
          {/* EVENTS */}
          <div className="space-y-1">
            {children}
          </div>
        </div>
      </div>
    );
  };



  const renderCalendar = (events: any[], dayPropGetter: (date: Date) => any) => (
    <Calendar
      formats={formats}
      localizer={localizer}
      events={events}
      // components={{ event: CustomEvent }}
      components={{
        toolbar: CustomToolbar,
        event: CustomEvent,
        dateCellWrapper: HolidayDateCellWrapper,
        week: {
          header: CustomWeekHeader,
        },
        day: {
          header: DayHeader
        },
        month: { header: MonthHeader },
      }}
      selectable
      // views={["day", "week", "month"]}
      views={["month", "week", "day"]}
      view={currentView}
      onView={(view) => setCurrentView(view)}
      date={currentDate}
      onNavigate={(date) => {
        setCurrentDate(date);
        setSelectedSidebarDate(date); // ok to keep
      }}
      // onDrillDown is not needed for cell clicks
      scrollToTime={scrollToTime}
      startAccessor={(event: any) => event.start}
      endAccessor={(event: any) => event.end}
      step={60}
      timeslots={1}
      eventPropGetter={getEventPropGetter}
      dayPropGetter={dayPropGetter}
      onSelectEvent={(event: any) => {
        if (event.id) {
          if (event.originalEventId && event.originalEventId !== event.id) {
            const masterEvent = calendarEvents.find(e => e.id === event.originalEventId);
            if (masterEvent) {
              setSelectedEvent({
                ...masterEvent,
                startTime: event.startTime,
                endTime: event.endTime,
              });
            }
          } else {
            setSelectedEvent(event);
          }
          setIsModalOpen(true);
        }
      }}
      onSelectSlot={(slotInfo) => {
        const clickedDate = new Date(slotInfo.start);
        const action = (slotInfo as any).action; // "click" | "select"

        // Always update sidebar date
        setSelectedDate(clickedDate);
        setSelectedSidebarDate(clickedDate);

        const isMonthView = currentView === "month";
        const isWeekOrDayView = currentView === "week" || currentView === "day";

        /**
         * ❌ BLOCK MODAL OPEN
         * - Month view single click
         * - Week/Day single click
         */
        if (
          action === "click" &&
          (isMonthView || isWeekOrDayView)
        ) {
          return;
        }

        /**
         * ✅ ALLOW MODAL ONLY FOR DRAG SELECT
         * (week/day only)
         */
        if (action !== "select") return;

        // Below logic only for creating new appointment (week/day view, drag select, etc.)
        const selectedStart = new Date(slotInfo.start);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        selectedStart.setHours(0, 0, 0, 0);

        if (selectedStart < today) {
          toast.warning("Cannot schedule meeting in past date.");
          return;
        }

        setSelectedEvent({
          id: "",
          title: "",
          description: "",
          ownerUserID: userId,
          location: "",
          meetingDetails: "",
          ownerColor: "",
          participantUserIds: [],
          externalUserEmails: [],
          startTime: slotInfo.start.toISOString(),
          endTime: slotInfo.end.toISOString(),
          taskId: 1,
          taskTitle: "",
          online: true,
          timeOffEmpData: [],
          isSprout: true,
          ownerName: "",
          recurrenceRule: undefined,
          parentEventId: undefined,
          time_zone: undefined,
        });
        setIsModalOpen(true);
      }}
      className={`${currentView}-custom-view  ${calendarClassName}`}
    />

  );

  const filteredExpandedTeamEvents = useMemo(() => {
    if (!selectedTeam) return [];

    const view = currentView === 'work_week' ? 'week' : currentView === 'agenda' ? 'day' : currentView;
    const viewStart = moment(currentDate).startOf(view as moment.unitOfTime.StartOf).toDate();
    const viewEnd = moment(currentDate).endOf(view as moment.unitOfTime.StartOf).toDate();

    const allTeamEvents: AllEvent[] = filteredTeamEvents.map((e: any) => ({
      ...e,
      // Ensure team events are also in the AllEvent format
      start: moment.utc(e.startTime).toDate(),
      end: moment.utc(e.endTime).toDate(),
    }));

    const expanded: Event[] = expandRecurringEvents(allTeamEvents, viewStart, viewEnd);

    return expanded.map(e => {
      const originalEvent = allTeamEvents.find(orig => orig.id === e.originalEventId) || calendarEvents.find(orig => orig.id === e.originalEventId);
      return {
        ...originalEvent!,
        id: e.id,
        title: e.title,
        start: e.date,
        end: moment(e.date).add(e.elapsedTimeInMinutes, 'minutes').toDate(),
        startTime: e.date.toISOString(),
        endTime: moment(e.date).add(e.elapsedTimeInMinutes, 'minutes').toISOString(),
        originalEventId: e.originalEventId,
        parentEventId: e.parentEventId,
        recurrenceRule: e.recurrenceRule,
        time_zone: e.time_zone,
      };
    });
  }, [selectedTeam, filteredTeamEvents, calendarEvents, currentView, currentDate]);

  return (
    <>
      <div className="w-full xl:flex">
        <div style={{ display: 'flex', flexDirection: 'column' }} className="w-full xl:w-[78%] h-[calc(100vh-120px)]">
          {loading && <Loader />}
          <div className="calender_top_bar mb-3">
            <div className="flex flex-wrap gap-x-3 gap-y-1.5 justify-between w-full">
              <div className="items-center flex flex-wrap gap-x-3 gap-y-1.5">
                <div className="relative mb-0 text-sm w-[240px]">
                  <MultiSelectDropdown label="" name="users" values={selectedEmployees} onChange={handleParticipantChange} options={participantOptions} isWhiteBg={true} />
                </div>
                {/* <div className="mb-0 text-sm" style={{ width: '200px' }}>
                <SelectDropdown isWhiteBg={true} label="" name="team" value={selectedTeam} onChange={handleTeamChange} options={teamOptions} isSearchable={true} />
              </div> */}
                <button className="bg-white w-[110px] py-1.5 text-[#212121] text-[14px] font-medium rounded-[10px]" onClick={() => { clearSelection(); setSelectedTeam(""); fetchAllEvents(); }}>
                  Clear
                </button>
                <div className="hidden md:block">
                  <MeetingTypeInfo />
                </div>

              </div>
              <div className="items-end flex flex-wrap gap-x-3 gap-y-1.5">
                {isOwner && (
                  <button
                    onClick={() => setHolidayOpen(true)}
                    className="bg-[#F9F6FF] text-[#364153] text-[14px] px-[14px] py-1.5 rounded-[10px] flex justify-center gap-2"
                    style={{
                      border: "1px solid #EFE9FA"
                    }}
                  >
                    <Star className="text-[#7E57C2] text-[18px] pt-1" /> <p className="m-0">Holidays</p>
                  </button>)}
                <button className="
    inline-flex items-center gap-3
    bg-transparent border-0 cursor-pointer
    font-poppins text-[16px] font-medium text-black
    px-2 py-1
  " ref={buttonRef} onClick={() => { setIsModalOpen(true); setSelectedEvent({ id: "", title: "", description: "", ownerUserID: userId, location: "", meetingDetails: "", ownerColor: "", participantUserIds: [], externalUserEmails: [], startTime: "", endTime: "", taskId: 1, taskTitle: "", online: true, timeOffEmpData: [], isSprout: true, ownerName: "" }); }}>
                  <span className="whitespace-nowrap">
                    Add Appointment
                  </span>

                  <img
                    src={ADD}
                    alt="Add"
                    className="w-full h-full object-contain"
                  />
                  {/* <span className="w-8 h-8">
              </span> */}
                </button>
                <div className="block md:hidden w-[100px]">
                  <MeetingTypeInfo />
                </div>
              </div>

            </div>
          </div>
          <div style={{ flex: 1, position: "relative", minHeight: 0 }}
            className="bg-white rounded-[10.12px] px-4 pt-3 pb-2">
            {selectedTeam
              ? renderCalendar(filteredExpandedTeamEvents, (date: Date) => {
                const today = new Date();

                const isToday =
                  date.getDate() === today.getDate() &&
                  date.getMonth() === today.getMonth() &&
                  date.getFullYear() === today.getFullYear();

                const isSelected =
                  selectedDate &&
                  date.getDate() === selectedDate.getDate() &&
                  date.getMonth() === selectedDate.getMonth() &&
                  date.getFullYear() === selectedDate.getFullYear();

                /* ===============================
                   WEEK VIEW
                =============================== */
                if (currentView === "week") {
                  if (isSelected || (!selectedDate && isToday)) {
                    return {
                      style: {
                        backgroundColor: "#7E57C21A",
                      },
                    };
                  }
                  return {};
                }

                /* ===============================
                   MONTH VIEW
                =============================== */
                if (currentView === "month") {
                  if (isSelected) {
                    return {
                      style: {
                        backgroundColor: "#7E57C21A",
                        boxShadow: "inset 0 0 0 1px #7E57C2",
                      },
                    };
                  }

                  if (!selectedDate && isToday) {
                    return {
                      style: {
                        boxShadow: "inset 0 0 0 1px #7E57C2",
                      },
                    };
                  }
                }

                return {};
              })
              : renderCalendar(filteredExpandedEvents, (date: Date) => {
                const today = new Date();

                const isToday =
                  date.getDate() === today.getDate() &&
                  date.getMonth() === today.getMonth() &&
                  date.getFullYear() === today.getFullYear();

                const isSelected =
                  selectedDate &&
                  date.getDate() === selectedDate.getDate() &&
                  date.getMonth() === selectedDate.getMonth() &&
                  date.getFullYear() === selectedDate.getFullYear();

                /* ===============================
                   WEEK VIEW
                =============================== */
                if (currentView === "week") {
                  if (isSelected || (!selectedDate && isToday)) {
                    return {
                      style: {
                        backgroundColor: "#7E57C21A",
                      },
                    };
                  }
                  return {};
                }

                /* ===============================
                   MONTH VIEW
                =============================== */
                if (currentView === "month") {
                  if (isSelected) {
                    return {
                      style: {
                        backgroundColor: "#7E57C21A",
                        boxShadow: "inset 0 0 0 1px #7E57C2",
                      },
                    };
                  }

                  if (!selectedDate && isToday) {
                    return {
                      style: {
                        boxShadow: "inset 0 0 0 1px #7E57C2",
                      },
                    };
                  }
                }

                return {};
              })}
          </div>
          {selectedEvent?.id ? (
            <ModalMeet isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} widthClass={"max-w-[570px]"}>
              <ViewEvent
                event={selectedEvent}
                onClose={() => { setIsModalOpen(false); setSelectedEvent(null); }}
                refreshAllEvents={fetchAllEvents}

              />

            </ModalMeet>

          ) : (
            <ModalMeet isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
              <AddEvent event={selectedEvent} onClose={() => setIsModalOpen(false)} onEventCreated={fetchAllEvents} calanderView={currentView} />
            </ModalMeet>
          )}

          {/* Add RescheduleMeetingModal */}
          <ModalMeet isOpen={showRescheduleModal} onClose={() => setShowRescheduleModal(false)}>
            {selectedEvent && (
              <RescheduleMeetingModal
                handleCloseRescheduleModal={() => setShowRescheduleModal(false)}
                rescheduleModal={true}
                authToken={token}
                selectedMeeting={{
                  id: selectedEvent.id,
                  title: selectedEvent.title,
                  startTime: selectedEvent.startTime,
                  endTime: selectedEvent.endTime,
                  description: selectedEvent.description,
                  ownerUserID: selectedEvent.ownerUserID,
                  meetingDetails: selectedEvent.meetingDetails,
                  location: selectedEvent.location,
                  participantUsers: selectedEvent.participantUserIds.map(id => ({
                    participantId: id,
                    participantName: employees.find(emp => emp.userId === id)?.userName || id
                  })),
                  externalUserEmails: selectedEvent.externalUserEmails,
                  ownerColor: selectedEvent.ownerColor,
                  ownerName: selectedEvent.ownerName,
                  online: selectedEvent.online,
                  isSprout: selectedEvent.isSprout
                }}
                refreshMeeting={() => {
                  fetchAllEvents();
                }}
              />
            )}
          </ModalMeet>
        </div>
        <div className="w-full xl:w-[22%] pb-20 overflow-auto h-fit lg:ps-5 pt-2">

          {/* TOP DATE TEXT */}
          <p className="text-[#4A5565] text-sm m-0">
            {selectedSidebarDate.toDateString() === new Date().toDateString()
              ? "Today"
              : selectedSidebarDate.toLocaleDateString('en-US', { weekday: 'long' })
            }
          </p>

          {/* BIG DATE */}
          <p className="text-base text-[#101828]">
            {selectedSidebarDate.toLocaleDateString('en-US', {
              month: 'long',
              day: 'numeric',
              year: 'numeric',
            })}
          </p>

          {/* EVENT LIST */}
          <div className="space-y-4">
            {filteredExpandedEvents
              // ?.filter((event: any) => {
              //   try {
              //     const eventStartDate = new Date(event.startTime);
              //     const sidebarDate = new Date(selectedSidebarDate);

              //     // Reset hours to compare dates properly
              //     sidebarDate.setHours(0, 0, 0, 0);
              //     eventStartDate.setHours(0, 0, 0, 0);

              //     return eventStartDate.getTime() === sidebarDate.getTime();
              //   } catch (error) {
              //     console.warn("Error parsing event date:", event.startTime, error);
              //     return false;
              //   }

              ?.filter((event: any) => {
                try {
                  const meetingStart = moment(event.startTime).startOf("day");
                  const meetingEnd = moment(event.endTime).startOf("day");
                  const selectedDay = moment(selectedSidebarDate).startOf("day");

                  return selectedDay.isSameOrAfter(meetingStart) &&
                    selectedDay.isSameOrBefore(meetingEnd);
                } catch {
                  return false;
                }
              })
              .map((event: any, index: number) => {
                return <div
                  key={event.id || index}
                  className="event-card"
                  onClick={() => {
                    setSelectedEvent(event);
                    setIsModalOpen(true);
                  }}
                >
                  <EventCard
                    title={event.title || "-"}
                    startTime={moment.utc(event.startTime).local().format("hh:mm A")}
                    endTime={moment.utc(event.endTime).local().format("hh:mm A")}
                    color={event.ownerColor}
                    attendees={event.participantUserIds}
                    onEdit={() => {
                      setSelectedEvent(event);
                      setIsModalOpen(true);
                    }}
                    onDelete={() => {
                      // Handle delete functionality
                      handleDeleteEvent(event);
                    }}
                    onReschedule={() => {
                      // Handle reschedule functionality
                      handleRescheduleEvent(event);
                    }}
                  />
                </div>;
              })
            }

            {/* NO EVENTS MESSAGE */}
            {/* {filteredExpandedEvents &&
            filteredExpandedEvents.filter((event: any) => {
              try {
                const eventStartDate = new Date(event.startTime);
                const sidebarDate = new Date(selectedSidebarDate);

                sidebarDate.setHours(0, 0, 0, 0);
                eventStartDate.setHours(0, 0, 0, 0);

                return eventStartDate.getTime() === sidebarDate.getTime();
              } catch {
                return false;
              }
            }).length === 0 && ( */}

            {filteredExpandedEvents &&
              filteredExpandedEvents.filter((event: any) => {
                try {
                  const meetingStart = moment(event.startTime).startOf("day");
                  const meetingEnd = moment(event.endTime).startOf("day");
                  const selectedDay = moment(selectedSidebarDate).startOf("day");

                  return selectedDay.isSameOrAfter(meetingStart) &&
                    selectedDay.isSameOrBefore(meetingEnd);
                } catch {
                  return false;
                }
              }).length === 0 && (
                <div className="text-center py-24 text-gray-500">
                  <p>No events scheduled for this date!</p>
                </div>
              )
            }
            {/* 
              <div className="text-center py-24 text-gray-500">
                <p>No events scheduled for this date!</p>
              </div> */}
            {/* ) */}
            {/* } */}
          </div>
        </div>
      </div>

      <HolidaySidebar
        open={openHoliday}
        onClose={() => setHolidayOpen(false)}
        onHolidaySuccess={fetchAllEvents}
      />

    </>
  );
};

export default MyCalendar;
